module.exports = __webpack_public_path__ + "static/img/face3.8a9ca20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face3.png
// module id = 0b9Y
// module chunks = 1